var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAwesomeUserFriends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 17.5,
    viewBox: "0 0 25 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-friends",
    "data-name": "Icon awesome-user-friends",
    d: "M7.5,11A4.375,4.375,0,1,0,3.125,6.625,4.373,4.373,0,0,0,7.5,11Zm3,1.25h-.324a6.04,6.04,0,0,1-5.352,0H4.5A4.5,4.5,0,0,0,0,16.75v1.125A1.875,1.875,0,0,0,1.875,19.75h11.25A1.875,1.875,0,0,0,15,17.875V16.75A4.5,4.5,0,0,0,10.5,12.25ZM18.75,11A3.75,3.75,0,1,0,15,7.25,3.751,3.751,0,0,0,18.75,11Zm1.875,1.25h-.148a4.926,4.926,0,0,1-3.453,0h-.148a4.339,4.339,0,0,0-2.176.6,5.717,5.717,0,0,1,1.551,3.9v1.5c0,.086-.02.168-.023.25h6.9A1.875,1.875,0,0,0,25,16.625,4.373,4.373,0,0,0,20.625,12.25Z",
    transform: "translate(0 -2.25)",
    fill: "#446fa2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeUserFriends);
export default __webpack_public_path__ + "static/media/icon-awesome-user-friends.f87739b2b0aa7560aac3bf7c7a087c65.svg";
export { ForwardRef as ReactComponent };